import React, { useState, useEffect } from "react";
import RegimeSelector from "./components/RegimeSelector";
import HRAForm from "./components/HRAForm";
import InvestmentDeclaration from "./components/InvestmentDeclaration";
import LiveTaxImpact from "./components/LiveTaxImpact";
import ProofSubmissionModal from "./components/ProofSubmissionModal";
import { getTaxRegime, postUpdateTaxRegime } from "../../ApiHelper/url_Helpers";
import { toasterError, toasterSuccess } from "../../Components/toaster";

const TDS = () => {
  const [regime, setRegime] = useState("new"); // "new" or "old"
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTaxRegime();
  }, []);

  const fetchTaxRegime = async () => {
    try {
      setLoading(true);
      const response = await getTaxRegime();
      if (response && response.data && response.data.regime) {
        setRegime(response.data.regime);
      }
    } catch (error) {
      console.error("Error fetching tax regime:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRegimeChange = async (newRegime) => {
    try {
      setRegime(newRegime);
      await postUpdateTaxRegime({ regime: newRegime });
      toasterSuccess(`Tax regime updated to ${newRegime}`);
    } catch (error) {
      console.error("Error updating tax regime:", error);
      toasterError("Failed to update tax regime");
      // Revert on failure
      fetchTaxRegime();
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold">TDS</h1>
        {loading && <span className="text-sm text-gray-500">Loading...</span>}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          {/* Tax Regime Selector */}
          <RegimeSelector regime={regime} setRegime={handleRegimeChange} />

          {/* HRA Form */}
          <HRAForm disabled={regime === "new"} />

          {/* Investment Declaration */}
          <InvestmentDeclaration 
            disabled={regime === "new"} 
            onGoToProofs={() => setIsModalOpen(true)} 
          />
        </div>

        {/* Live Tax Impact Sidebar */}
        <div className="lg:col-span-1">
          <LiveTaxImpact regime={regime} />
        </div>
      </div>

      {/* Proof Submission Modal */}
      {isModalOpen && (
        <ProofSubmissionModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)} 
          regime={regime} 
        />
      )}
    </div>
  );
};

export default TDS;
